import { createI18n } from 'vue-i18n'

function loadLocaleMessages () {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messages: any = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    })
    return messages;
}

const i18n = createI18n({
    legacy: false, // Enable Composition API mode
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
});

// Needed for i18n outside of components. Don't use in components
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalT = (key: string, params?: (string | number)[] | Record<string, unknown>): string => (i18n.global as any).t(key, params || {}) as string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalTE = (key: string): string => (i18n.global as any).te(key);

export default i18n;
